import { fetch } from '../../services/api';

const endPoints = '/api/me';


export const update = (data) => fetch(endPoints + '/update', data, 'post');
export const password = data => fetch(`${endPoints}/change-password`, data, 'put');






// WEBPACK FOOTER //
// ./src/services/session/account.js